import Model from './Model';

export default class Encoder extends Model {
  resource() {
    return 'encoders';
  }
}
